import { render } from "./PointGuessingActive.vue?vue&type=template&id=77aeedc4&scoped=true&ts=true"
import script from "./PointGuessingActive.vue?vue&type=script&setup=true&lang=ts"
export * from "./PointGuessingActive.vue?vue&type=script&setup=true&lang=ts"

import "./PointGuessingActive.vue?vue&type=style&index=0&id=77aeedc4&scoped=true&lang=scss"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77aeedc4"],['__file',"src/views/me/PointGuessingActive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77aeedc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77aeedc4', __exports__)) {
    console.log('reload')
    api.reload('77aeedc4', __exports__)
  }
  
  module.hot.accept("./PointGuessingActive.vue?vue&type=template&id=77aeedc4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('77aeedc4', render)
  })

}


export default __exports__